export const UploadTaskAction = {
    None: "none",
    Delete: "delete",
    Create: "create",
    Update: "update",
    Skip: "skip",
}

export class UploadTask {
    ID;
    File;
    Crc;
    Filename;
    Tags = [];
    Action;
    #status = [];

    get Status() {
        return this.#status;
    }

    AddStatus(status){
        this.#status.push(status);
        if (status.isCritical()) {
            this.Action = UploadTaskAction.Skip;
        }
    }

    ClearStatus() {
        this.#status = [];
    }

    GetStatusString(){
        if (this.Status.length > 0)
            return this.Status?.map(s => s.stylizedMessage()).join("<br/>");
        else return "";
    }
}